/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_BreakInputs */

const en_platform_preview_break = /** @type {(inputs: Platform_Preview_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break`)
};

const pl_platform_preview_break = /** @type {(inputs: Platform_Preview_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przerwa`)
};

/**
* | output |
* | --- |
* | "Break" |
*
* @param {Platform_Preview_BreakInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_break = /** @type {((inputs?: Platform_Preview_BreakInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_BreakInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_break(inputs)
	return en_platform_preview_break(inputs)
});